/**
 * SL24 Form (new) — owns plan / one-time selection (does not rely on legacy jQuery).
 */
(function () {
  // Alias global PROJ — do NOT redeclare/wipe window.PROJ (breaks ajaxcart / mini-cart)
  window.PROJ = window.PROJ || {};
  var PROJ = window.PROJ;

  function moneyFormat(cents, format) {
    cents = parseInt(cents, 10) || 0;
    format = format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '');
    var withoutZero = withComma.replace(/\.00$/, '');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, withoutZero.indexOf('.') === -1 ? withoutZero + '.00' : withComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, withComma);
  }

  function formatMoney(form, cents) {
    var format = form.getAttribute('data-money-format') || (window.theme && theme.moneyFormat) || '${{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return moneyFormat(cents, format);
  }

  function setPlantype(form, type) {
    form.setAttribute('plantype', type);
  }

  function syncSelectedState(form) {
    var plantype = form.getAttribute('plantype');
    form.querySelectorAll('.fn-plan').forEach(function (plan) {
      plan.classList.remove('is-selected');
    });

    if (plantype === 'js-option-plan') {
      var activePlan = form.querySelector('.fn-plan--sub .sl-var.active');
      if (activePlan) {
        var wrap = activePlan.closest('.fn-plan');
        if (wrap) wrap.classList.add('is-selected');
      }
      var otMain = form.querySelector('.fn-plan--ot .fn-plan__main');
      var otTrigger = form.querySelector('[data-fn-ot-trigger][role="radio"]');
      if (otMain) otMain.classList.remove('active');
      if (otTrigger) otTrigger.setAttribute('aria-checked', 'false');
    } else {
      var otPlan = form.querySelector('.fn-plan--ot');
      if (otPlan) otPlan.classList.add('is-selected');
      var otMainOn = form.querySelector('.fn-plan--ot .fn-plan__main');
      var otTriggerOn = form.querySelector('[data-fn-ot-trigger][role="radio"]');
      if (otMainOn) otMainOn.classList.add('active');
      if (otTriggerOn) otTriggerOn.setAttribute('aria-checked', 'true');
    }

    form.querySelectorAll('.fn-plan--sub .sl-var').forEach(function (el) {
      el.setAttribute('aria-checked', el.classList.contains('active') ? 'true' : 'false');
    });
  }

  function updateButtonPrice(form) {
    var active = form.querySelector('.sl-var.active');
    if (!active) return;
    var price = parseInt(active.getAttribute('data-price'), 10) || 0;
    var compare = parseInt(active.getAttribute('data-compare'), 10) || 0;
    var html = '';
    if (price > 0) {
      html = ' - <span class="fn-btn-now">' + formatMoney(form, price) + '</span>';
      if (compare > price) {
        html += ' <s class="fn-btn-was">' + formatMoney(form, compare) + '</s>';
      }
    }
    form.querySelectorAll('[data-fn-btn-price]').forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function updateOtSummary(form) {
    var activeOt = form.querySelector('.fn-ot-btn.active');
    if (!activeOt) return;
    var price = parseInt(activeOt.getAttribute('data-price'), 10) || 0;
    var compare = parseInt(activeOt.getAttribute('data-compare'), 10) || 0;
    var priceEl = form.querySelector('[data-fn-ot-price]');
    var compareEl = form.querySelector('[data-fn-ot-compare]');
    if (priceEl) priceEl.innerHTML = formatMoney(form, price);
    if (compareEl) {
      if (compare > price) {
        compareEl.hidden = false;
        compareEl.innerHTML = '<s>' + formatMoney(form, compare) + '</s>';
      } else {
        compareEl.hidden = true;
        compareEl.innerHTML = '';
      }
    }
    var otPlan = form.querySelector('.fn-plan--ot');
    if (otPlan) {
      otPlan.setAttribute('data-price', String(price));
      otPlan.setAttribute('data-compare', String(compare));
    }
  }

  function findBestPlan(form) {
    var best = null;
    var bestScore = -1;
    form.querySelectorAll('.fn-plan--sub').forEach(function (plan) {
      var save = parseInt(plan.getAttribute('data-save-cents'), 10) || 0;
      var months = parseInt(plan.getAttribute('data-months'), 10) || 0;
      var score = save * 100 + months;
      if (score > bestScore) {
        bestScore = score;
        best = plan;
      }
    });
    return best;
  }

  function otScore(btn) {
    var save = parseInt(btn.getAttribute('data-save-cents'), 10) || 0;
    var price = parseInt(btn.getAttribute('data-price'), 10) || 0;
    // Prefer higher savings, then larger pack (higher price)
    return save * 1000000 + price;
  }

  function findHigherOtOption(form) {
    var active = form.querySelector('.fn-ot-btn.active');
    if (!active) return null;
    var activeSave = parseInt(active.getAttribute('data-save-cents'), 10) || 0;
    var activeScore = otScore(active);
    var best = null;
    var bestScore = activeScore;

    form.querySelectorAll('.fn-ot-btn.available').forEach(function (btn) {
      if (btn === active) return;
      var score = otScore(btn);
      if (score > bestScore) {
        bestScore = score;
        best = btn;
      }
    });

    if (!best) return null;
    var bestSave = parseInt(best.getAttribute('data-save-cents'), 10) || 0;
    // Only promote when it's an actual extra saving, not just a pricier pack
    if (bestSave <= activeSave) return null;
    return best;
  }

  function updateSwitchBanners(form) {
    form.querySelectorAll('[data-fn-switch]').forEach(function (el) {
      el.hidden = true;
      el.innerHTML = '';
    });

    function fill(target, html) {
      if (!target) return;
      target.hidden = false;
      target.innerHTML = html;
    }

    var plantype = form.getAttribute('plantype');

    // One-time: only promote a better one-time variant (more save / larger pack)
    if (plantype === 'js-option-single') {
      var higherOt = findHigherOtOption(form);
      if (!higherOt) return;
      var activeOt = form.querySelector('.fn-ot-btn.active');
      var otSwitch = form.querySelector('.fn-plan--ot [data-fn-switch]');
      var title = higherOt.getAttribute('data-title') || 'larger pack';
      var higherSave = parseInt(higherOt.getAttribute('data-save-cents'), 10) || 0;
      var activeSave = activeOt ? parseInt(activeOt.getAttribute('data-save-cents'), 10) || 0 : 0;
      var delta = higherSave - activeSave;
      var bits = [];
      if (delta > 0) bits.push('Save <strong>' + formatMoney(form, delta) + '</strong>');
      bits.push('with the ' + String(title).toLowerCase());
      fill(
        otSwitch,
        bits.join(' ') + ' — <button type="button" data-fn-switch-to="' + higherOt.getAttribute('varid') + '">Switch</button>'
      );
      return;
    }

    // Subscription: promote best subscription plan
    var best = findBestPlan(form);
    if (!best) return;
    var bestVar = best.querySelector('.sl-var');
    if (!bestVar) return;
    var bestSave = parseInt(best.getAttribute('data-save-cents'), 10) || 0;
    var bestTitle = best.getAttribute('data-title') || 'subscription';
    var freeShip = best.getAttribute('data-free-ship') === 'true';
    var activeWrap = form.querySelector('.fn-plan--sub.is-selected');
    if (!activeWrap || activeWrap === best) return;
    var activeSave = parseInt(activeWrap.getAttribute('data-save-cents'), 10) || 0;
    var delta = bestSave - activeSave;
    if (delta <= 0 && !freeShip) return;
    var msg = [];
    if (delta > 0) msg.push('Save <strong>' + formatMoney(form, delta) + '</strong>');
    if (freeShip) msg.push((msg.length ? 'and get ' : 'Get ') + 'free shipping');
    msg.push('with the ' + bestTitle.toLowerCase() + '.');
    fill(
      activeWrap.querySelector('[data-fn-switch]'),
      msg.join(' ') + ' <button type="button" data-fn-switch-to="' + bestVar.getAttribute('varid') + '">Switch</button>'
    );
  }

  function refresh(form) {
    syncSelectedState(form);
    updateOtSummary(form);
    updateButtonPrice(form);
    updateSwitchBanners(form);
  }

  // Wait for the .fn-plan__expanded collapse/expand transition (0.35s) before measuring
  function lockHeader(ms) {
    window.headerScrollLockUntil = Math.max(window.headerScrollLockUntil || 0, Date.now() + ms);
  }

  function revealPlan(plan) {
    if (!plan) return;
    clearTimeout(revealPlan.timer);
    revealPlan.timer = setTimeout(function () {
      // offsetHeight ignores the hide-on-scroll transform, so the gap is kept even while the header is hidden
      var header = document.getElementById('shopify-section-header');
      var headerH = (header && header.offsetHeight) ||
        parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var gap = 12;
      var top = plan.getBoundingClientRect().top;
      if (top >= headerH + gap && top < window.innerHeight - 60) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      lockHeader(1000);
      window.scrollTo({
        top: window.pageYOffset + top - headerH - gap,
        behavior: reduce ? 'auto' : 'smooth'
      });
    }, 380);
  }

  function applySelection(form, variableEl, options) {
    options = options || {};
    if (!variableEl) return;

    // Upsells from form1 snippet — treat as one-time
    if (variableEl.closest('.sub-pro-upsell, .upsell-bundle-wrap')) {
      variableEl.setAttribute('data-fn-type', 'single');
      variableEl.setAttribute('data-selling-plan', '');
      if (!variableEl.getAttribute('data-price')) {
        var priceNode = variableEl.querySelector('.price-js');
        // leave blank; button will still update from data-price if set later
      }
    }

    var force = !!options.force;
    if (!force && variableEl.classList.contains('active') && form.getAttribute('plantype') === (variableEl.getAttribute('data-fn-type') === 'plan' ? 'js-option-plan' : 'js-option-single')) {
      refresh(form);
      return;
    }

    lockHeader(600);

    var variantId = variableEl.getAttribute('varid');
    var sellingPlan = variableEl.getAttribute('data-selling-plan') || '';
    var fnType = variableEl.getAttribute('data-fn-type') || 'single';

    form.querySelectorAll('.variable').forEach(function (el) {
      el.classList.remove('active');
    });
    variableEl.classList.add('active');

    setPlantype(form, fnType === 'plan' ? 'js-option-plan' : 'js-option-single');

    var sp = form.querySelector('.selling-plan-id');
    if (sp) sp.value = fnType === 'plan' ? sellingPlan : '';

    var idInput = form.querySelector('form input[name="id"]');
    if (idInput && variantId) idInput.value = variantId;

    var addBtn = form.querySelector('button[name="add"]');
    if (addBtn) {
      if (variableEl.classList.contains('available')) addBtn.removeAttribute('disabled');
      else addBtn.setAttribute('disabled', '');
    }

    if (window.PROJ && PROJ.pdp && typeof PROJ.pdp.updateCartDetails === 'function') {
      PROJ.pdp.updateCartDetails(form, variantId);
    }

    var imgVarId = variableEl.getAttribute('data-imgvar-id');
    if (imgVarId) {
      var thumb = document.querySelector('[data-assign-var="' + imgVarId + '"]');
      if (thumb && window.jQuery) {
        var ind = jQuery(thumb).index();
        var $gal = jQuery('.acc-gal').find('.gallery-inside');
        if ($gal.length && $gal.data('flickity')) $gal.flickity('select', ind);
        if (window.Flickity && document.querySelector('.sl-main-gal')) {
          var flk = Flickity.data('.sl-main-gal');
          if (flk) flk.select(ind);
        }
      }
    }

    var loyal = parseInt(variableEl.getAttribute('data-loypoint'), 10);
    if (loyal > 0) {
      var loyalEl = document.getElementById('loyal-points');
      if (loyalEl) loyalEl.textContent = String(loyal);
    }

    var newUrl = '?variant=' + variantId;
    if (fnType === 'plan' && sellingPlan) newUrl += '&selling_plan=' + sellingPlan;
    try {
      window.history.pushState(null, '', newUrl);
    } catch (err) {}

    refresh(form);
    revealPlan(variableEl.closest('.fn-plan'));
  }

  function selectOt(form) {
    var otBtn =
      form.querySelector('.fn-ot-btn.active') ||
      form.querySelector('.fn-ot-btn.available') ||
      form.querySelector('.fn-ot-btn');
    if (otBtn) {
      applySelection(form, otBtn, { force: true });
    } else {
      setPlantype(form, 'js-option-single');
      var sp = form.querySelector('.selling-plan-id');
      if (sp) sp.value = '';
      refresh(form);
    }
  }

  function addToCartAjax(formRoot, cartForm) {
    var $ = window.jQuery;
    if (!$ || !cartForm) return false;

    var $cartForm = $(cartForm);
    var $btn = $cartForm.find('button[type="submit"]');
    // Use class only — [disabled] CSS swaps Add to bag → Sold out
    if ($btn.hasClass('is-adding')) return false;
    $btn.addClass('is-adding disabled');
    $('#mini-cart').addClass('loading');

    var payload = $cartForm.serialize();
    var qtyInput = formRoot.querySelector('.qty-input');
    if (qtyInput && payload.indexOf('quantity=') === -1) {
      payload += '&quantity=' + encodeURIComponent(qtyInput.value || '1');
    }
    // Empty selling_plan can confuse some cart apps — drop if blank
    payload = payload.replace(/(^|&)selling_plan=(?=&|$)/, '$1').replace(/&&/g, '&').replace(/^&|&$/g, '');

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: payload,
      success: function (itemData) {
        var cuid = $('[data-upsell-var="' + itemData.id + '"]');
        if (cuid.length && typeof window.callUpsell === 'function') {
          window.callUpsell(cuid);
        } else if (PROJ.ajaxcart) {
          PROJ.ajaxcart.updateCart();
          PROJ.ajaxcart.opencart();
        }
        $btn.removeClass('is-adding disabled');
        $('body').removeClass('hidetop');
      },
      error: function () {
        if (PROJ.ajaxcart) PROJ.ajaxcart.updateCart();
        $btn.removeClass('is-adding disabled');
      }
    });
    return true;
  }

  function initForm(form) {
    if (form.dataset.fnReady === '1') return;
    form.dataset.fnReady = '1';

    // Tag upsell variables from shared snippet so selection treats them as one-time
    form.querySelectorAll('.sub-pro-upsell .variable, .upsell-bundle-wrap .variable').forEach(function (el) {
      el.setAttribute('data-fn-type', 'single');
      el.setAttribute('data-selling-plan', '');
      if (!el.getAttribute('data-price')) {
        el.setAttribute('data-price', el.getAttribute('data-loypoint') ? String(parseInt(el.getAttribute('data-loypoint'), 10) * 100) : '0');
      }
    });

    // ATC → ajax + mini cart (same behaviour as theme-custom.js)
    // Triggered from click / Enter, not submit: Customer Events counts a cart form submit
    // AND the /cart/add.js request, so submit + AJAX logged 2 adds.
    var cartForm = form.querySelector('[data-fn-atc-form]') || form.querySelector('form[action="/cart/add"]');
    if (cartForm) {
      var stopAll = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      };
      cartForm.addEventListener('click', function (e) {
        if (!e.target.closest('button[type="submit"], input[type="submit"]')) return;
        stopAll(e);
        addToCartAjax(form, cartForm);
      });
      cartForm.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.keyCode !== 13) return;
        if (!e.target.closest('input, select')) return;
        stopAll(e);
        addToCartAjax(form, cartForm);
      });
      cartForm.addEventListener('submit', stopAll);
    }

    // Capture phase so we win over legacy body-delegated jQuery handlers
    form.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('.fn-ot-var.is-oos')) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          return;
        }

        // Let native form controls / links work
        if (e.target.closest('a[href], button[type="submit"], .quantity-btn, input, textarea, label')) {
          if (!e.target.closest('[data-fn-switch-to]')) return;
        }

        var switchBtn = e.target.closest('[data-fn-switch-to]');
        if (switchBtn && form.contains(switchBtn)) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          var id = switchBtn.getAttribute('data-fn-switch-to');
          var target =
            form.querySelector('.fn-plan--sub .sl-var[varid="' + id + '"]') ||
            form.querySelector('.fn-ot-btn[varid="' + id + '"]');
          if (target) applySelection(form, target, { force: true });
          return;
        }

        // Frequency select — don't treat as plan click
        if (e.target.closest('select')) return;

        // Details / quick-view on upsell
        if (e.target.closest('[data-call-product-popup], .upsell-details')) return;

        var otTrigger = e.target.closest('[data-fn-ot-trigger]');
        if (otTrigger && form.contains(otTrigger)) {
          // Nested OT variants / upsells / controls — let later handlers run
          if (!e.target.closest('.fn-ot-btn, .variable, [data-fn-switch-to], a, select, button, .upsell-details, [data-call-product-popup]')) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            selectOt(form);
            return;
          }
        }

        // Clicking ribbon / card shell selects the plan variable inside
        var selectShell = e.target.closest('[data-fn-select]');
        if (selectShell && form.contains(selectShell)) {
          if (!e.target.closest('[data-fn-switch-to], a, select, button')) {
            var planVar = selectShell.querySelector('.sl-var.variable');
            if (planVar) {
              e.preventDefault();
              e.stopPropagation();
              if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
              applySelection(form, planVar);
              return;
            }
          }
        }

        var variable = e.target.closest('.variable');
        if (variable && form.contains(variable)) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          applySelection(form, variable);
        }
      },
      true
    );

    form.querySelectorAll('.selling-plan-change').forEach(function (sel) {
      sel.addEventListener('change', function (e) {
        e.stopPropagation();
        var wrap = sel.closest('[data-selling-plan]') || sel.closest('.sl-var');
        if (wrap) wrap.setAttribute('data-selling-plan', sel.value);
        var sp = form.querySelector('.selling-plan-id');
        if (sp) sp.value = sel.value;
        if (window.PROJ && PROJ.pdp && typeof PROJ.pdp.updateSubBenefitsFromPlan === 'function') {
          PROJ.pdp.updateSubBenefitsFromPlan(form, sel.value);
        }
        refresh(form);
      });
    });

    refresh(form);
  }

  function initAll() {
    document.querySelectorAll('[data-fn-form]').forEach(initForm);
  }

  // PROJ.pdp (js-pdp-24.js) is deferred, so selections made before it loaded need re-syncing
  function syncCartDetails() {
    document.querySelectorAll('[data-fn-form]').forEach(function (form) {
      var active = form.querySelector('.variable.active');
      if (active && window.PROJ && PROJ.pdp && typeof PROJ.pdp.updateCartDetails === 'function') {
        PROJ.pdp.updateCartDetails(form, active.getAttribute('varid'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      syncCartDetails();
    });
  } else {
    initAll();
  }

  PROJ.pdpFormNew = {
    init: initAll,
    refresh: function () {
      document.querySelectorAll('[data-fn-form]').forEach(refresh);
    }
  };
})();
